import Vue from 'vue'
import Router from 'vue-router'
import {InvenTory} from '@/View/InvenTory/Router/index.js'
import {HRM} from '@/View/HRM/router/index.js'
import {CRM} from '@/View/CRM/router/index.js'
import {Manufacture} from '@/View/Manufacture/Router/index.js'
import {Sales} from '@/View/Sales/Router/index.js'
import {SystemSetting} from '@/View/SystemSetting/Router/index.js'
import {Quality} from '@/View/QA/router/index.js'
Vue.use(Router)

export const constantRouterMap = [
  { // Dashboard object start
    path: '/login',
    component: () => import('@/View/login/login.vue'),
    hidden: true,
    name: 'login',
    meta: {
      title: 'login',
      selected: false,
      permissionList: []
    }
  },
  { // Dashboard object start
    path: '/networkDetails',
    component: () => import('@/View/login/networkInterfacesDetails.vue'),
    hidden: true,
    name: 'networkDetails',
    meta: {
      title: 'Networkdetails',
      selected: false,
      permissionList: []
    }
  },
  {
    path: '/',
    redirect: 'login'
  },
  { // Dashboard object start
    path: '/Dashboard',
    component: () => import('@/View/Dashboard/dashboard.vue'),
    hidden: true,
    name: 'dashboard',
    meta: {
      title: 'dashboard',
      selected: true,
      permissionList: []
    }
  },
  HRM,
  InvenTory,
  CRM,
  Manufacture,
  Sales,
  SystemSetting,
  Quality
]

export default new Router({
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js